var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';








const Card = ({ title, children, className, color = 'default' }) => {
  let headerColor;

  switch (color) {
    case 'yellow':
      headerColor = 'bg-yellow-100 text-yellow-800';
      break;
    default:
      headerColor = 'bg-gray-50 text-primary-700';
  }

  return /*#__PURE__*/(
    _jsx("div", { className: `border rounded-md border-gray-50 shadow-sm ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: `block w-full font-semibold text-base p-4 ${headerColor}` }, void 0, title), /*#__PURE__*/
    _jsx("div", { className: "p-4" }, void 0, children)
    ));

};

export { Card };